import { ComponentDesc, ComponentHeader } from "../ui";

const NoSubscription = ({
  copyConfig,
}: {
  copyConfig: {
    title: string;
    noSubLabel: string;
  };
}) => {
  return (
    <div className="mx-auto mt-10 w-full max-w-7xl items-center justify-between">
      <ComponentHeader text={copyConfig.title} />
      <ComponentDesc text={copyConfig.noSubLabel} />
    </div>
  );
};

export default NoSubscription;
